import { ReturnableTypeEnum } from "./returnable-type-enum";

export const ReturnableTypeLabel = Object.freeze({
  [ReturnableTypeEnum.DELIVERY_ORDER]: "Surat Jalan",
  [ReturnableTypeEnum.SALES_INVOICE]: "Faktur Penjualan",
  [ReturnableTypeEnum.NON_INVOICE]: "Non-Faktur",
});
